import { render } from "./InputCode.vue?vue&type=template&id=1bd714dc&scoped=true&ts=true"
import script from "./InputCode.vue?vue&type=script&lang=ts"
export * from "./InputCode.vue?vue&type=script&lang=ts"

import "./InputCode.vue?vue&type=style&index=0&id=1bd714dc&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd714dc"]])

export default __exports__